import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import { TaxValidationConfig } from "./validateTaxRegistration";

function normalizeTaxValidationConfig(
  config: Record<string, unknown>
): TaxValidationConfig {
  return {
    countryCode: config.countryCode ?? config.country_code,
    validationEnabled: config.validationEnabled ?? config.validation_enabled,
    minLength: config.minLength ?? config.min_length,
    maxLength: config.maxLength ?? config.max_length,
    numericOnly: config.numericOnly ?? config.numeric_only,
    errorMessage: config.errorMessage ?? config.error_message
  } as TaxValidationConfig;
}

export function resolveTaxValidationConfig(
  countryCode: string
): TaxValidationConfig | undefined {
  let configs = FlagsPermissionClient.config_tax_validation_by_country.getValue() as unknown;
  if (typeof configs === "string") {
    try {
      configs = JSON.parse(configs);
    } catch {
      configs = [];
    }
  }

  if (!Array.isArray(configs)) {
    return undefined;
  }

  const code = (countryCode || "").trim().toUpperCase();
  const config = configs.find(
    (c: Record<string, unknown>) =>
      String(c?.countryCode ?? c?.country_code ?? "").trim().toUpperCase() === code
  );

  return config ? normalizeTaxValidationConfig(config) : undefined;
}
